import React, { useEffect, useState } from 'react';
import './Header.scss';
import tw from '../../_assets/_img/icons/tw.svg';
import fb from '../../_assets/_img/icons/fb.svg';
import ig from '../../_assets/_img/icons/ig-white.svg';
import copy from '../../_assets/_img/icons/copy.svg';
import { useScrollYPosition } from 'react-use-scroll-position';

const Header = () => {

  const scrollPos = useScrollYPosition();
  const [openMenu, setOpenMenu] = useState(false);
  
  return (
    <header className="cnn-sponsorcontent-header">
      <nav className="cnn-navbar">
        <a href="https://www.cnn.com" data-analytics="header_logo" className="cnn-logo">
          <img src="https://i.cdn.turner.com/cnn/.element/img/4.0/logos/cnn_logo_badge.png" alt="CNN Logo Badge"/>
        </a>
        <a className="back-to-cnn"href="https://www.cnn.com">&lt; Back to CNN </a>
        <div className="social-bar">
          <span>
            <a href="https://www.facebook.com/hulu/" target="_blank">
              <img src={fb} />
            </a>
          </span>
          <span>
            <a href="https://twitter.com/hulu" target="_blank">
              <img src={tw} />
            </a>
          </span>
          <span>
            <a href="https://www.instagram.com/hulu/" target="_blank">
              <img src={ig} />
            </a>
          </span>
          <span>
            <a href="">
              <img src={copy} />
            </a>
          </span>
        </div>
      </nav>
      <div className="header-banner">Content by Hulu</div>
      <div className="article-header">
        <div className="progress">
          <div style={{width: `${(scrollPos / document.body.clientHeight + .15) * 100}%`}}></div>
        </div>
        <div className="hamburger" onClick={() => setOpenMenu(!openMenu)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <p className="article-title">Emi's Journey</p>
      </div>
      <div className={`dropdown ${openMenu ? 'opened' : ''}`}>
        <a target="_blank" href="https://sponsorcontent.cnn.com/interactive/huluhandmaidstale/freedomjourneys/hub/"><p className=" article-header article-title">Home: Freedom Is Just The Beginnning</p></a>
      </div>
    </header>
  );
}

export default Header;
